<div class="reports-graphs-percentages">
  <common-mojo-card>
    <mojo-functions-and-departments-filters
      [datePickerFilter]="true"
      [selectedFunctionFn]="jobFunction.value"
      [selectedDepartment]="jobDepartment.value"
      (datePickerValuesChange)="applyDateFilter($event)"
      [minDate]="minDate$ | async"
      (filterChange)="applyFilters($event)"
    >
    </mojo-functions-and-departments-filters>
  </common-mojo-card>
</div>
<common-mojo-card>
  <common-mojo-funnel-chart
    [elements]="referralCountsByStage$ | async"
    [formControl]="stage"
  >
    <ng-template
      let-element
      let-index="index"
      let-active="active"
      let-selected="selected"
    >
      <div
        class="header"
        [ngClass]="{'active': active, 'selected': selected}"
      >
        <span class="label">{{element.name | titlecase}}</span>
        <div class="values">
          <span class="total">{{element.total}}</span>
          <span class="percent">{{ (getPercentage(index) | async) | percent
            }}</span>
        </div>
        <span class="current">Current: {{element.count}}</span>
      </div>
    </ng-template>
  </common-mojo-funnel-chart>
</common-mojo-card>

<div class="referrals-list">
  <div class="referred-radio-buttons-header">
    <div>
      Referred
      <mat-radio-group
        class="referred-radio-buttons"
        [formControl]="referralOption"
      >
        <mat-radio-button
          *ngFor="let btn of radioButtons"
          [value]="btn.value"
          class="mojo-blue-hover"
        >
          {{btn.label}}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div
      (click)="sendReferralReportSEmail()"
      class="cursos-pointer"
    >
      <img src="../../../../../assets/icons/cloud_blue.svg">
    </div>

  </div>
  <common-mojo-card>
    <mojo-referral-reports-charts
      (departmentSelection)="selectDepartment($event)"
      (functionSelection)="selectFunction($event)"
    >
    </mojo-referral-reports-charts>

    <div
      class="referred-content"
      *ngIf="{
      items: (referralReportsList$ | async),
      isLoading: (isPageLoading$ | async),
      isLoaded: (isPageLoaded$ | async)
      } as report"
    >
      <div *ngIf="!report.items || report.items.totalElements === 0">
        <ng-container *ngIf="report.isLoading === false; else loading">
          No referral reports available
        </ng-container>
      </div>
      <div *ngIf="report.items.totalElements> 0 && report.isLoaded">
        <div class="report-header">
          <div class="col-sm-4">
            {{referralOption.value === 1 ? 'Job' : 'Employee'}}
            <span class="total">{{report.items.totalElements}}</span>
          </div>
          <div class="col-sm-3 no-mobile">
            {{referralOption.value === 1 ? 'Employee' : 'Job'}}
          </div>
          <div class="col-sm-2 no-mobile">Referred Candidate</div>
          <div class="col-sm-1 no-mobile">Date</div>
          <div class="col-sm-2 no-mobile">Phase</div>
        </div>
        <div class="report-items">
          <mojo-referral-reports-list-item
            *ngFor="let item of report.items.content"
            [referralReportItem]="item"
            [showBy]="referralOption.value === 1 ? 'Job' : 'Employee'"
          ></mojo-referral-reports-list-item>
        </div>

        <mojo-pagination
          [pagination]="report.items"
          (pageChange)="changePage($event)"
        >
        </mojo-pagination>
      </div>
    </div>
    <ng-template #loading>
      <mat-spinner
        [diameter]="48"
        [strokeWidth]="4"
        class="loader"
      ></mat-spinner>
    </ng-template>
  </common-mojo-card>
</div>
